// extracted by mini-css-extract-plugin
export default {"price":"Z9-z","onSale":"_9-z","msrpLabelPrice":"a--z","msrpLabel":"b--z","originalPrice":"c--z","percentOff":"d--z"};